// removed by extract-text-webpack-plugin
module.exports = {"button":"_1yNs7","wrapper":"_2d3ll","label":"_2bz7-","bubble":"zMtYa"};


//////////////////
// WEBPACK FOOTER
// ./app/components/icon-button/icon-button.scss
// module id = 1480
// module chunks = 7